import { Component, OnInit, ViewChild } from '@angular/core';
import { GroupBookingDetailComponent } from '../group-booking-detail/group-booking-detail.component';
import { GroupBookingListItem } from '../group-booking-list-item';
import { HttpService } from '../service/http.service';

@Component({
  selector: 'app-group-bookings',
  templateUrl: './group-bookings.component.html',
  styleUrls: ['./group-bookings.component.css']
})
export class GroupBookingsComponent implements OnInit {

  showingDetail = false;
  selectedGroupId!: number | null;
  @ViewChild("detailComponent") detailComponent!: GroupBookingDetailComponent;

  groups: GroupBookingListItem[] = [];

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    this.httpService.getAllBookingGroups().subscribe(res => {
      this.groups = res;
    });
  }

  activateDetail(groupId: number){
    this.selectedGroupId = groupId;
    this.showingDetail = true;
    this.detailComponent.updateGroup(groupId);
  }

  closeDetail(){
    this.selectedGroupId = null;
  }

}
